import React, { Component, ReactNode } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip';

import { Well } from 'react-bootstrap';

import { ILoanAccountContact } from '../../../interfaces';

import { contactColumns, TOOLTIP_LOAN_ACCOUNT_CONTACTS } from './Columns';

interface IProps {
  canChange: boolean;
  contacts: ILoanAccountContact[];
  // Shares the title's row, as the loans and compliance tables do
  newButton?: ReactNode;
  onEdit: (contactId: string) => void;
  onRemove: (contactId: string) => void;
}

@autoBindMethods
@observer
class ContactsTable extends Component<IProps> {
  @computed
  private get columns () {
    const { canChange, onEdit, onRemove } = this.props;
    return contactColumns({ canChange, onEdit, onRemove });
  }

  private renderTable () {
    const { contacts } = this.props;

    // An account starts with none, and keeps the heading and its Add button while it has none, rather
    // than showing bare column headers.
    if (!contacts.length) {
      return <div className='empty'>There are no contacts for this account.</div>;
    }

    return (
      <ReactTable
        className='-list -no-scroll'
        columns={this.columns}
        data={contacts}
        keyField='id'
        minRows={0}
        pageSize={contacts.length}
        resizable={false}
        showPagination={false}
        // As on the case contacts table: an account has a handful of contacts, and they arrive from
        // the API in name order
        sortable={false}
      />
    );
  }

  public render () {
    return (
      // A plain well rather than .well-table, which drops the well's padding for a full-bleed table.
      // With the -list style's flush first and last cells, the columns then line up with the heading
      // and the button above them, as they do on the case contacts table.
      <Well className='loan-account-contacts-list'>
        {/* The heading says what these contacts are for, the type not being on the rows */}
        <h3>
          Invoice/Payments Contacts
          <div className='title-actions'>{this.props.newButton}</div>
        </h3>
        {this.renderTable()}

        <ReactTooltip
          effect='solid'
          html
          id={TOOLTIP_LOAN_ACCOUNT_CONTACTS}
          place='bottom'
          type='info'
        />
      </Well>
    );
  }
}

export default ContactsTable;
